// extracted by mini-css-extract-plugin
export default {"modalWrapper":"GdprModal_modalWrapper__F90Bc","icon":"GdprModal_icon__TEKrE","contentWrapper":"GdprModal_contentWrapper__Fq3I3"};